import types from './mutations-types';

const mutations = {
  [types.SET_USER](state, payload) {
    state.user = {
      ...state.user,
      ...payload,
    };
  },
  [types.SET_PROFILE](state, payload) {
    state.userProfile = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js